export default "__VITE_ASSET__BBBLX5C0__"